<template>
  
  <el-row :gutter="20" class="top-block">

    <Breadcrumb :route="this.$route"></Breadcrumb>

    


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24" style="padding: 20px">

      <el-tabs v-model="activeName" @tab-click="handleTabClick">

        <el-tab-pane label="待簽" name="unsign">
          <el-main>
            <el-badge :is-dot="item.total>0" class="item mr-10 mt-10" v-for="(item,idx) in jobTypeOptions" :key="idx" >
              <el-button size="small" @click.prevent="handleJobTypeClick(`${item.value}`)">{{item.label}}</el-button>
            </el-badge>

            <el-button v-if="userInfo.deletePermission === 1" type="warning" size="small" class="mr-10 mt-10 float-right" @click.prevent="exeBatchSign">批次簽核 <i class="el-icon-edit"></i></el-button>

            
            <el-table :data="filteredTableData" empty-text="目前無資料" 
                stripe header-row-class-name="headerStyle" class="mt-20"
                @selection-change="handleSelectChange">

              <el-table-column v-if="userInfo.deletePermission === 1" type="selection" width="35" :selectable="disabledCheckBox"></el-table-column>

              <el-table-column prop="flow" label="標題">
                <template slot-scope="scope">
                  <router-link　:to="`${scope.row.mytodo.todoUrl}review/${scope.row.id}`">{{scope.row.mytodo.startDate | fmtDate}} {{scope.row.mytodo.title}}</router-link>
                    <p class="mt-10">申請人:{{ scope.row.relatedUserObj.username }}</p>
                </template>
              </el-table-column>
              
              <el-table-column  label="狀態" width="130">
                <template slot-scope="scope">
                  {{scope.row.mytodo.status | fmtSignResult}}
                </template>
              </el-table-column>
            </el-table>

            <!-- <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNumUnsign"
                  :page-size="pageSizeUnsign"
                  :total="totalUnsign"
                  @current-change="handleCurrentUnsignChange">
              </el-pagination>

            </div> -->

          </el-main>
        </el-tab-pane>

        <el-tab-pane label="已簽" name="signed">
          
          <el-main>
            <el-row class="ml-20 mr-20" >
              <el-col :xs="12" :sm="12" :lg="12">
                <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
              </el-col>
            </el-row>
            <el-table :data="tableDataSigned" empty-text="目前無資料" stripe header-row-class-name="headerStyle" class="mt-20">
              
              <el-table-column prop="flow" label="標題"　width="140">
                <template slot-scope="scope">
                  <router-link　:to="`${scope.row.mytodo.todoUrl}review/${scope.row.id}`">{{scope.row.mytodo.startDate | fmtDate}} {{scope.row.mytodo.title}}</router-link>
                </template>
              </el-table-column>

              <el-table-column label="申請人" width="80">
                <template slot-scope="scope">
                  <p class="mt-10">{{ scope.row.relatedUserObj.username }}</p>
                </template>
              </el-table-column>

              <el-table-column label="狀態" >
                <template slot-scope="scope">
                  <el-tag :type="caseType(scope.row.mytodo.status)">{{ scope.row.mytodo.status | fmtSignResult}}</el-tag>
                </template>

                
              </el-table-column>


            </el-table>
            <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNum"
                  :page-size="pageSize"
                  :total="total"
                  @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </el-main>
        </el-tab-pane>

        <el-tab-pane label="已簽日報" name="signed-daily">
          
          <el-main>
            <el-row class="ml-20 mr-20" >
              <el-col :xs="12" :sm="12" :lg="12">
                <el-button icon="el-icon-search" circle type="warning" @click="drawerDaily = true"></el-button>
              </el-col>
            </el-row>
            <el-table :data="tableDataSignedDaily" empty-text="目前無資料" stripe header-row-class-name="headerStyle" class="mt-20">
              <el-table-column prop="flow" label="標題">
                <template slot-scope="scope">
                  <router-link　:to="`${scope.row.mytodo.todoUrl}review/${scope.row.id}`">{{scope.row.mytodo.startDate | fmtDate}} {{scope.row.mytodo.title}}</router-link>
                </template>
              </el-table-column>

              <el-table-column label="申請人">
                <template slot-scope="scope">
                  <p class="mt-10">{{ scope.row.relatedUserObj.username }}</p>
                </template>
              </el-table-column>


            </el-table>
            <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNumDaily"
                  :page-size="pageSizeDaily"
                  :total="totalDaily"
                  @current-change="handleCurrentChangeDaily">
              </el-pagination>
            </div>
          </el-main>
        </el-tab-pane>


        <el-tab-pane label="所有日報/單據" name="not-mine" v-if="isVp()">
          
          <el-main>
            <el-row class="ml-20 mr-20" >
              <el-col :xs="12" :sm="12" :lg="12">
                <el-button icon="el-icon-search" circle type="warning" @click="drawerNotMine = true"></el-button>
              </el-col>
            </el-row>
            <el-table :data="tableDataNotMine" empty-text="目前無資料" stripe header-row-class-name="headerStyle" class="mt-20">
              <el-table-column prop="flow" label="標題">
                <template slot-scope="scope">
                  <router-link　:to="`${scope.row.mytodo.todoUrl}review/${scope.row.id}`">{{scope.row.mytodo.startDate | fmtDate}} {{scope.row.mytodo.title}}</router-link>
                </template>
              </el-table-column>

              <el-table-column label="申請人">
                <template slot-scope="scope">
                  <p class="mt-10">{{ scope.row.relatedUserObj.username }}</p>
                </template>
              </el-table-column>


            </el-table>
            <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNumNotMine"
                  :page-size="pageSizeNotMine"
                  :total="totalNotMine"
                  @current-change="handleCurrentChangeDaily">
              </el-pagination>
            </div>
          </el-main>
        </el-tab-pane>

        
      </el-tabs>
    </el-col>


    <el-drawer
        size="70%"
        title="搜尋已簽核工作"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">

        <el-main>
            <el-row class="ml-20 mr-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span class="demonstration">起 </span>
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="選擇日期" class="mt-10">
                  </el-date-picker>
              </el-col>
            </el-row>
            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >迄 </span>
                <el-date-picker
                  v-model="endDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="選擇日期" class="mt-10">
                </el-date-picker>
              </el-col>
            </el-row>

            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="6">
                <span >標題</span>
                <br/>
                <el-input v-model="jobTitle" autocomplete="off" placeholder="輸入標題"></el-input>

               <!--  <el-autocomplete
                  class="inline-input full-width-input mt-10"
                  v-model="jobTitle"
                  placeholder="輸入標題"
                ></el-autocomplete> -->
                
              </el-col>
            </el-row>

            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >人員</span>
                <br/>
                <el-autocomplete
                  class="inline-input full-width-input mt-10"
                  v-model="empLabel"
                  :fetch-suggestions="queryEmp"
                  placeholder="輸入員工姓名或工號"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  clearable
                ></el-autocomplete>
                
              </el-col>
            </el-row>

          </el-main>

      <el-button type="primary" @click.prevent="search" class="mt-20 ml-20">查詢</el-button>
      <el-button type="normal" @click.prevent="clearQuery" class="mt-20 ml-10">清除條件</el-button>
    </el-drawer>

    <el-drawer
        size="70%"
        title="搜尋已簽核日報"
        :visible.sync="drawerDaily"
        :direction="direction"
        :before-close="handleDailyClose">

        <el-main>
            <el-row class="ml-20 mr-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span class="demonstration">起 </span>
                  <el-date-picker
                    v-model="startDateDaily"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="選擇日期" class="mt-10">
                  </el-date-picker>
              </el-col>
            </el-row>
            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >迄 </span>
                <el-date-picker
                  v-model="endDateDaily"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="選擇日期" class="mt-10">
                </el-date-picker>
              </el-col>
            </el-row>

            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >地區</span>
                <br/><br/>
                <el-select v-model="selectedArea" placeholder="選擇地區" @change="handleUserQuery">
                  <el-option v-for="t in areaOptions"
                             :key="t.id"
                             :label="t.label"
                             :value="t.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>

            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >職務</span>
                <br/><br/>
                <el-select v-model="selectedRole" placeholder="選擇職務" @change="handleUserQuery">
                  <el-option v-for="t in roleOptions"
                             :key="t.id"
                             :label="t.name"
                             :value="t.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>

            <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >選擇人員</span>
                <br/><br/>
                <el-select v-model="empIdDaily" placeholder="選擇人員" @change="handleUser">
                  <el-option v-for="t in userOptions"
                             :key="t.id"
                             :label="t.username"
                             :value="t.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            
            <!-- <el-row class="ml-20 mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >人員</span>
                <br/>
                <el-autocomplete
                  class="inline-input full-width-input mt-10"
                  v-model="empLabelDaily"
                  :fetch-suggestions="queryEmp"
                  placeholder="輸入員工姓名或工號"
                  :trigger-on-focus="false"
                  @select="handleDailySelect"
                ></el-autocomplete>
              </el-col>
            </el-row> -->

          </el-main>

      <el-button type="primary" @click.prevent="searchDaily" class="mt-20 ml-20">查詢</el-button>
      <el-button type="normal" @click.prevent="clearDailyQuery" class="mt-20 ml-10">清除條件</el-button>
    </el-drawer>


    <el-drawer
        size="70%"
        title="搜尋日報"
        :visible.sync="drawerNotMine"
        :direction="direction"
        :before-close="handleNotMineClose">

      <el-main>
        <el-row class="ml-20 mr-20" >
          <el-col :xs="24" :sm="24" :lg="24">
            <span class="demonstration">起 </span>
              <el-date-picker
                v-model="startDateNotMine"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="選擇日期" class="mt-10">
              </el-date-picker>
          </el-col>
        </el-row>
        <el-row class="ml-20 mr-20 mt-20" >
          <el-col :xs="24" :sm="24" :lg="24">
            <span >迄 </span>
            <el-date-picker
              v-model="endDateNotMine"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="選擇日期" class="mt-10">
            </el-date-picker>
          </el-col>
        </el-row>

        <el-row class="ml-20 mr-20 mt-20" >
          <el-col :xs="24" :sm="24" :lg="6">
            <span >標題</span>
            <br/>
            <el-input v-model="jobTitleNotMine" autocomplete="off" placeholder="輸入標題"></el-input>

          </el-col>
        </el-row>

        <el-row class="ml-20 mr-20 mt-20" >
          <el-col :xs="24" :sm="24" :lg="24">
            <span >人員</span>
            <br/>
            <el-autocomplete
              class="inline-input full-width-input mt-10"
              v-model="empLabel"
              :fetch-suggestions="queryEmp"
              placeholder="輸入員工姓名或工號"
              :trigger-on-focus="false"
              @select="handleSelect"
              clearable
            ></el-autocomplete>
            
          </el-col>
        </el-row>

      </el-main>  
      <el-button type="primary" @click.prevent="searchNotMine" class="mt-20 ml-20">查詢</el-button>
      <el-button type="normal" @click.prevent="clearQueryNotMine" class="mt-20 ml-10">清除條件</el-button>
    </el-drawer>


    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="執行批次簽核"
               :visible.sync="signoff.dialog"
               :width="dw">

      <el-form :model="signoff" ref="batchSignForm" :rules="signoff.rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="signoff.signResult" label="Y">同意</el-radio>
              <el-radio v-model="signoff.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="signoff.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="signoff.dialog = false">取 消</el-button>
        <el-button type="primary" @click="sendBatchSignoff('batchSignForm')">確 定</el-button>
      </div>
    </el-dialog>
    

  </el-row>

</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import dayjs from "dayjs";

export default {
  name: "MySignOff",
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState('login', ['userInfo']),
  },
  data() {
    let checkRadio = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('請選擇同意或退回'))
      } else {
        callback()
      }
    }

    return {
      drawer: false,
      drawerDaily: false,
      direction: 'ltr',
      currentTab: 'unsign',
      activeName: 'unsign',
      pageNum:1,
      pageSize:15,
      total:0,

      tableData:[],
      filteredTableData:[],
      tableDataSigned:[],
      
      // pageNumUnsign:1,
      // pageSizeUnsign:25,
      // totalUnsign:0,
      
      jobType:'',
      jobTypeOptions:[],

      empId:'',
      empLabel:'',
      startDate:'',
      endDate:'',
      jobTitle:'',
      
      empIdDaily:'',
      empLabelDaily:'',
      startDateDaily:'',
      endDateDaily:'',
      tableDataSignedDaily:[],
      pageNumDaily:1,
      pageSizeDaily:15,
      totalDaily:0,

      selectedItem:'',
      didQuery: false,
      didQueryDaily: false,
      queryAll: 'N',

      selectedArea:'',
      areaOptions:[
        {value: '北區', label: '北區'},
        {value: '中區', label: '中區'},
        {value: '南區', label: '南區'}
      ],
      selectedRole:'',
      roleOptions:[],

      selectedUser:'',
      userOptions:[],

      dw: '50%',
      signoff:{
        dialog: false,
        notes: '',
        rules: {
          signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
        },
        signResult:'',
        ids:[]
      },
      multipleSelection:[],

      drawerNotMine: false,
      didQueryNotMine: false,
      tableDataNotMine:[],
      pageNumNotMine:1,
      pageSizeNotMine:15,
      totalNotMine:0,
      empIdNotMine:'',
      empLabelNotMine:'',
      startDateNotMine:'',
      endDateNotMine:'',
      jobTitleNotMine:''
    }
  },
  methods: {
    handleClose(){
      this.drawer = false
    },
    handleDailyClose(){
      this.drawerDaily = false
    },
    
    handleCurrentChange(val) {
      this.pageNum = val
      this.didQuery = true
      this.loadMySignedJob()
    },
    handleCurrentChangeDaily(val){
      this.pageNumDaily = val
      this.didQueryDaily = true
      this.loadDailySignedJob()
    },
    // handleCurrentUnsignChange(val){
    //   this.pageNumUnsign = val
    //   //this.didQueryUnsign = true
    //   this.loadMyJob()
    // },
    loadMyJob() {
      localStorage.setItem('LH_MY_SIGNOFF_URL', '')
      localStorage.setItem('LH_SIGN_OFF_TAB', 'unsign')
      
      this.activeName = 'unsign'
      this.didQuery =false

      this.request.get("/job/myjob").then(res => {
        this.tableData = res.data
        this.filteredTableData = res.data

        //this.totalUnsign = res.data.total
      
        

        let daily_job = ['for_brand_sales',
        'for_oa_acct',
        'for_district_manager',
        'for_oa_adm',
        'for_painting',
        'for_oa_planning',
        'for_fin_manager',
        'for_product_sales']

        let daily = 0
        let reqBuy = 0
        let reqPay = 0
        let reqCash = 0
        let reqItem = 0
        let reqMiles = 0

        let opt_eng = []
        let opt = [{ label:'全部', value:'all', total:this.tableData.length }]
        for(var i=0 ; i<this.tableData.length ; i++) {
          let job = this.tableData[i]
          if (daily_job.includes(job.todoType)) {
            daily++
          }
          if (job.todoType === 'req_buy') {
            reqBuy++
          }
          if (job.todoType === 'req_pay') {
            reqPay++
          }
          if (job.todoType === 'petty-cash') {
            reqCash++
          }
          if (job.todoType === 'req_item') {
            reqItem++
          }
          if (job.todoType === 'req_miles') {
            reqMiles++
          }
        }

        opt.push({ label:'工作日報', value:'for_', total: daily})
        opt.push({ label:'請款單', value:'req_pay', total: reqPay})
        opt.push({ label:'請購單', value:'req_buy', total: reqBuy})
        opt.push({ label:'零用金請款單', value:'petty-cash', total: reqCash})
        opt.push({ label:'用品請領單', value:'req_item', total: reqItem})
        opt.push({ label:'哩程補貼申請單', value:'req_miles', total: reqMiles})

        this.jobTypeOptions = opt

        this.handleJobTypeClick(this.selectedItem)

      })
    },
    loadMySignedJob() {
      console.log('已簽:loadMySignedJob')
      localStorage.setItem('LH_SIGN_OFF_TAB', 'signed')
      this.activeName = 'signed'

      let url = ''
      console.log('didQuery:', this.didQuery)
      if (this.didQuery) {
        url = this.getQueryUrl()
        localStorage.setItem('LH_MY_SIGNOFF_URL', url)

      } else {
         url = localStorage.getItem('LH_MY_SIGNOFF_URL')
         console.log('url=>', url)
         if (url === null || typeof url === 'undefined' || url === '') {
            url = this.getQueryUrl()
         } 
      }

      this.request.get(url).then(res => {
        this.tableDataSigned = res.data.records
        this.total = res.data.total
      })
    },
    loadDailySignedJob(){
      localStorage.setItem('LH_SIGN_OFF_TAB', 'signed-daily')
      this.activeName = 'signed-daily'
      //console.log('didQueryDaily:', this.didQueryDaily)
      let url = ''
      if (this.didQueryDaily) {
        url = this.getDailyQueryUrl()
        localStorage.setItem('LH_DAILY_SIGNED_URL', url)

      } else {
         url = localStorage.getItem('LH_DAILY_SIGNED_URL')
         if (url === null || typeof url === 'undefined') {
            url = this.getDailyQueryUrl()
         } 
      }

      this.request.get(url).then(res => {
        this.tableDataSignedDaily = res.data.records
        this.totalDaily = res.data.total
      })

    },
    getQueryUrl(){
      let {pageNum, pageSize, startDate, endDate, empId, jobTitle} = this
        if (startDate === null) { startDate = ''}
        if (endDate === null) { endDate = ''}

        let url = "/job/myjob/signed?pageNum="+pageNum+"&pageSize="+pageSize+"&startDate="+startDate+"&endDate="+endDate+"&empId="+empId+"&jobTitle="+jobTitle
        return url
    },
    handleTabClick(tab, event) {
      //console.log(tab.name);
      this.currentTab = tab.name

      localStorage.setItem('LH_SIGN_OFF_TAB', tab.currentTab)

      if (tab.name === 'unsign') {
        this.didQuery = false
        this.didQueryDaily = false
        this.didQueryNotMine = false
        this.loadMyJob()
      } else if (tab.name === 'signed') {
        this.didQuery = false
        this.didQueryDaily = false
        this.didQueryNotMine = false
        this.loadMySignedJob()
      } else if (tab.name === 'signed-daily') {
        this.didQuery = false
        this.didQueryDaily = false
        this.didQueryNotMine = false
        this.loadDailySignedJob()
      } else if (tab.name === 'not-mine') {
        this.didQuery = false
        this.didQueryDaily = false
        this.didQueryNotMine = true
        this.loadNotMyJob()
      }
    },
    getDailyQueryUrl(){
      let {pageNumDaily, pageSizeDaily, startDateDaily, endDateDaily, empIdDaily, queryAll} = this
        if (startDateDaily === null) { startDateDaily = ''}
        if (endDateDaily === null) { endDateDaily = ''}

        let url = "/job/myjob/signed-daily?pageNum="+pageNumDaily+"&pageSize="+pageSizeDaily+"&startDate="+startDateDaily+"&endDate="+endDateDaily+"&empId="+empIdDaily+"&queryAll="+queryAll
        return url
    },
    handleJobTypeClick(item){
      let q = {
        selectedItem : item
      }
      
      localStorage.setItem('LH_SIGN_OFF_ITEM', JSON.stringify(q))

      if (item === 'all') {
          this.filteredTableData = this.tableData
        } else {
          this.filteredTableData = this.tableData.filter(data => data.todoType.indexOf(item) !== -1)
        }
    },
    handleInvalid(){
      this.request.post("/todo/invalid/" + id).then(res => {
          if (res.code === '200') {
            this.loadData()
            this.showResult('success', '資料作廢成功.')
          } else {
            this.showResult('error', '資料作廢失敗.')
          }
      })
    },
    caseType(status) {
      if (status === 'draft') return ''
      if (status === 'review') return 'warning'
      if (status === 'reject') return 'danger'
      if (status === 'close') return 'success'
      if (status === 'invalid') return 'danger'
    },
    loadEmp(){
      this.request.get("/user").then(res => {
        console.log(res)
      })
    },


    search() {
      this.drawer = false
      this.didQuery = true
      this.loadMySignedJob()
    },

    searchDaily() {
      this.drawerDaily = false
      this.didQueryDaily = true
      this.queryAll = 'Y'
      this.loadDailySignedJob()
    },
    clearQuery() {
      this.drawer = false
      this.startDate = ''
      this.endDate = ''
      this.empLabel = ''
      this.empId = ''
      this.jobTitle = ''
      this.didQuery = true
      this.loadMySignedJob()
    },

    clearDailyQuery() {
      this.selectedArea = ''
      this.selectedRole = ''
      this.selectedUser = ''
      this.queryAll = 'N'

      this.drawerDaily = false
      this.startDateDaily = ''
      this.endDateDaily = ''
      this.empLabelDaily = ''
      this.empIdDaily = ''

      this.didQueryDaily = true
      this.loadDailySignedJob()
    },

    queryEmp(str, cb){
      
      this.request.get("/user/q?keyword=" + str).then(res => {
        if (res.code === '200') {

          let list = res.data.map((item) => {
            return {
              value: item.username,
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleSelect(item) {
      this.empId = item.id
      this.empIdNotMine = item.id
    },
    handleDailySelect(item) {
      this.empIdDaily = item.id
    },

    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = '400' // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = '90%'
      } else {
        this.dw = '50%'
      }
    },

    sendBatchSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let ids = this.multipleSelection.map( e => e.id)
          this.signoff.ids = ids

          let data = {
            ids,
            notes: '',
            signResult: this.signoff.signResult
          }

          this.request.post("/job/batch/signoff", data).then(res => {
            if (res.code === '200') {
              this.showResult('success', '批次簽核完成')
              this.loadMyJob()
              this.signoff.dialog = false

              this.request.post("/job/batch/signoff/execution", {}).then(res => {
                
              })


            } else {
              this.showResult('error', '批次簽核執行失敗')
            }
          })


          // console.log('sendBatchSignoff:', this.signoff)
          // this.signoff.dialog = false

        }
      })
    },

    handleSelectChange(val){
      this.multipleSelection = val
    },
   
    exeBatchSign(){
      this.signoff.dialog = true
      this.signoff.notes = ''
    },

    disabledCheckBox(row){
      //console.log('row:', row.todoType, ' index:', index)
      if (row.todoType.indexOf('for_') !== -1) { 
        return true
      } else {
        return false
      }
    },

    loadRoles() {
      this.request.get("/role/signoff").then(res => {
            if (res.code === '200') {
              //console.log(res.data)
              this.roleOptions = res.data

            } else {
              this.showResult('error', '取得職務資料失敗')
            }
          })
    },

    handleUserQuery(){
      this.empIdDaily = ''
      this.request.get("/user/filter/q?area=" + this.selectedArea + "&role=" + this.selectedRole).then(res => {
        if (res.code === '200') {
          this.userOptions = res.data
        }
      })
    },
    handleRole(){
      console.log(this.selectedRole)
    },

    handleUser(){
      console.log(this.selectedUser)
    },

    getNotMineQueryUrl(){
      let {pageNumNotMine, pageSizeNotMine, startDateNotMine, endDateNotMine, empIdNotMine, jobTitleNotMine} = this
        if (startDateNotMine === null) { startDateNotMine = ''}
        if (endDateNotMine === null) { endDateNotMine = ''}

        let url = "/job/notmyjob?pageNum="+pageNumNotMine+"&pageSize="+pageSizeNotMine+"&startDate="+startDateNotMine+"&endDate="+endDateNotMine+"&empId="+empIdNotMine+"&jobTitle="+jobTitleNotMine
        console.log('url:', url)
        return url
    },
    loadNotMyJob() {

      localStorage.setItem('LH_SIGN_OFF_TAB', 'not-mine')
      this.activeName = 'not-mine'

      console.log('didQueryNotMine:', this.didQueryNotMine)
      
      let url = ''
      if (this.didQueryNotMine) {
        console.log('重新查詢 didQueryNotMine')

        url = this.getNotMineQueryUrl()
        localStorage.setItem('LH_NOT_MINE_URL', url)

      } else {
         url = localStorage.getItem('LH_NOT_MINE_URL')
         if (url === null || typeof url === 'undefined') {
            url = this.getNotMineQueryUrl()
         } else {
            //reverse query param
            let sd = '&startDate='
            let ed = '&endDate='
            let epId = '&empId='
            let jt = '&jobTitle='
            
            this.startDateNotMine = url.substring( url.indexOf(sd)+sd.length, url.indexOf(ed) )
            this.endDateNotMine = url.substring( url.indexOf(ed)+ed.length, url.indexOf(epId) )
            this.empIdNotMine = url.substring( url.indexOf(epId)+epId.length, url.indexOf(jt) )
            this.jobTitleNotMine = url.substring( url.indexOf(jt)+jt.length )

            console.log(this.startDateNotMine)
            console.log(this.endDateNotMine)
            console.log(this.empIdNotMine)
            console.log(this.jobTitleNotMine)
            
         } 
      }

      this.request.get(url).then(res => {
        this.tableDataNotMine = res.data.records
        this.totalNotMine = res.data.total
      })
    },
    searchNotMine() {
      this.drawerNotMine = false
      this.didQueryNotMine = true
      this.queryAll = 'N'
      this.loadNotMyJob()
    },
    handleNotMineClose(){
      this.drawerNotMine = false
    },
    handleCurrentChangeNotMine(val) {
      this.pageNumNotMine = val
      this.didQueryNotMine = true
      this.loadNotMyJob()
    },
    clearQueryNotMine() {
      this.drawerNotMine = false
      this.startDateNotMine = ''
      this.endDateNotMine = ''
      this.empLabel = ''
      this.empIdNotMine = ''
      this.jobTitleNotMine = ''
      this.didQueryNotMine = true
      this.loadNotMyJob()
    },
    isVp() {
      return (this.userInfo.role.engName === 'vp' || this.userInfo.role.engName === 'admin') 
    }

  },
  filters: {
    
    readOrNot(value) {

      return value === 'N' ? '否' : '是';
    }
  },
  mounted() {
    this.didQuery = false
    let currentTab = localStorage.getItem('LH_SIGN_OFF_TAB')
    console.log('currentTab:', currentTab)

    if (currentTab === null || typeof currentTab === 'undefined' || currentTab === 'unsign') {
      let cache = localStorage.getItem('LH_SIGN_OFF_ITEM')
      let cacheObj = JSON.parse(cache)
      if (cache !== null) {
        this.selectedItem = (typeof cacheObj.selectedItem === 'undefined')? '': cacheObj.selectedItem
      } else {
        this.selectedItem = 'all'
      }
      this.loadMyJob()
    } else if (currentTab === 'signed') {
      this.loadMySignedJob()
    } else if (currentTab === 'signed-daily') {
      this.queryAll = 'N'
      this.loadDailySignedJob()
    } else if (currentTab === 'not-mine') {
      this.queryAll = 'N'
      this.loadNotMyJob()
    }

    this.setDialogWidth();

    this.loadRoles();
    
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 8px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}

</style>
